import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { BottomRailColour } from '../../BottomRailColour';

export const CordloopImage = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const railColour = state.context.custom.railColour
    ? state.context.custom.railColour
    : 'Silver';
  const railColourHex = getHoneycombRailHexColour(railColour);
  return (
    <svg data-name="Layer 1" viewBox="0 0 8.16 456.05" {...props}>
      <path
        d="M3.64 456.05c-1.67 0-2.07 0-2.57-15.42-1.31-40.46-1.23-159-.76-248.14.27-51 .67-98.23 1.14-133.07.25-18.13.5-32.32.76-42.18C2.65.12 2.72.11 4.41 0h.12C6 0 6.11 1.45 6.18 2.22c1.29 13.22 2 129.31 2 234 0 29.16-.1 85.15-.53 132.51-.79 84.62-2.15 86.12-2.81 86.84a1.66 1.66 0 01-1.2.48zm.8-395.94c-.56 42.08-1 102.71-1.29 167.62C2.8 320 3 391.14 3.74 427.46c.87-35.39 1.39-103.82 1.42-192.36.01-59.32-.23-127.6-.72-174.99z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        fill={railColourHex}
        d="M3.64 455.05c-.66 0-1.1 0-1.57-14.45C.76 400.15.84 281.66 1.31 192.49c.27-50.86.69-98.11 1.14-133.06.25-18.14.5-32.33.76-42.16C3.63 1.06 3.84 1 4.47 1s.64.57.72 1.41c1.28 13.09 2 129.13 2 233.76 0 64.76-.37 215.7-3.08 218.68a.65.65 0 01-.47.2zM4.5 7.74c-1 23.72-1.95 114.19-2.35 220-.47 125.22.12 210.91 1.51 224.65 1.49-13.45 2.46-96.3 2.5-217.27.02-95.58-.58-200.68-1.66-227.38z"
      />
    </svg>
  );
};
